import type { ExtendedProductMainOffer } from 'src/areas/product/components/product-context';
import type { ProductMainOffer, ProductOffer } from 'src/types';

export const replaceMainOfferWithAlternativeOffer = (
  offer: ExtendedProductMainOffer,
  alternativeOffer: ProductOffer
) => {
  if (!alternativeOffer) return offer;

  const newAlternatives = [
    alternativeOffer,
    ...offer.alternativeOffers!.filter(alt => alt !== alternativeOffer),
  ];

  return {
    ...alternativeOffer,
    authorizedDealer: offer.authorizedDealer,
    history: offer.history,
    store: offer.store,
    alternativeOffers: newAlternatives,
    unfilteredShippings: offer.unfilteredShippings,
  } as ProductMainOffer;
};
